import React from 'react'
import * as Utils from '../util/Utils'

export default class RelativeDate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      relative: props.relative||true,
      locale: props.locale||'en-US',
    }
  }
  componentDidMount() {
    this.setup()
  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }
  setup() {
    const value = this.state.value
    if (typeof(value)==='number') {
      const date = new Date(value)
      this.setState({date:date})
    } else if (value instanceof Date) {
      this.setState({date:value})
    }
  }
  render() {
    return (
      <span className={this.props.className} style={{cursor:'pointer'}} onClick={()=>{
        this.setState({relative:!this.state.relative})
      }}>
        {
          this.state.date instanceof Date&&
          <React.Fragment>
            {
              this.state.relative&&
              Utils.timeAgo(this.state.date.getTime())
            }
            {
              this.state.relative!==true&&
              this.state.date.toLocaleString(this.state.locale)
            }
          </React.Fragment>
        }
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RelativeDate.js